import(/* webpackMode: "eager" */ "/app/components/Comments.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Figcaption.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/MdxImageLightbox.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/ScrollTopAndComment.tsx");
;
import(/* webpackMode: "eager" */ "/app/css/prism.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/katex/dist/katex.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/pliny/ui/BlogNewsletterForm.js");
